import React, { useContext } from 'react';
import { Gallery } from '../../Models/Models';
import { SiteContext } from '../../Contexts';
import { Utils } from '../../Services/Utils';
import CropBox from '../Image/CropBox';

/** Title images render at 400 × 300, so the window is locked to 4 : 3 and may not shrink below it. */
export const TITLE_CROP = { width: 400, height: 300 };

interface GalleryTitleCropperProps {
    gallery: Gallery;
    setGallery: React.Dispatch<React.SetStateAction<Gallery>>;
}

const GalleryTitleImageCropper: React.FC<GalleryTitleCropperProps> = ({ gallery, setGallery }) => {
    const { currentSite }: any = useContext(SiteContext);
    const titleImage = gallery.titleImage;

    if (!titleImage) return null;

    return (
        <div>
            <CropBox
                key={titleImage.imageId}
                imageUrl={Utils.getOriginalImageFilePath(currentSite.id, titleImage.imageId)}
                imageAlt={titleImage.alt || 'Titulný obrázok'}
                aspect={TITLE_CROP.width / TITLE_CROP.height}
                minWidth={TITLE_CROP.width}
                initial={Utils.parseCropName(titleImage.filePath)}
                onChange={coords => setGallery(prev => ({ ...prev, coordinates: coords }))}
            />
            <p className="st-crop-hint">
                Výrez posuňte ťahaním, veľkosť zmeňte rohmi.
            </p>
        </div>
    );
};

export default GalleryTitleImageCropper;
